import { GenericResponseType } from "../../types/response.ts";
import CapitalizationUtil from "../../utils/CapitalizationUtil.ts";
import { COMMON_API_URL } from "../../constants/urls";

const postData = async (
  jwt: string,
  callfunc: string,
  additionalParams?: object
): Promise<any> => {
  const response = await fetch(`${COMMON_API_URL}/${callfunc}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify({ ...additionalParams }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data: GenericResponseType =
    CapitalizationUtil.convertTopLevelKeysToCamelCase(await response.json());

  if (data.error) {
    throw new Error(data.error);
  }

  return data.result;
};

const UserService = {
  getMyUsers: (jwt: string) => postData(jwt, "getMyUsers"),
  getUserData: (jwt: string, userId: string) =>
    postData(jwt, "getUserData", { user_id: userId }),
  saveUser: (jwt: string, userData: object) =>
    postData(jwt, "user_write", { userData: userData }),
};

export default UserService;
